// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Returns20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Returns20: FC<Returns20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="21"
        >
            <path
                stroke="#000"
                d="m6.521 8.93 1.584 1.583-.355.356-3.043-3.043L7.75 4.783l.355.355-1.584 1.584-.853.854H12c.98 0 1.797.337 2.48 1.02s1.02 1.5 1.02 2.48-.337 1.797-1.02 2.48-1.5 1.02-2.48 1.02H6.5v-.5H12a2.91 2.91 0 0 0 2.124-.876A2.91 2.91 0 0 0 15 11.076a2.91 2.91 0 0 0-.876-2.124A2.91 2.91 0 0 0 12 8.076H5.668l.853.853Z"
            />
        </svg>
    );
};

export default Returns20;
